import { IHttpResponse, IHttpService, IPromise } from 'angular';
import * as _ from 'underscore';
import { ServiceLocator } from '~src/app/ServiceLocator';
import { toNativePromise } from '~src/commonInfra/utils/QUtils';
import { ListResult } from '~src/ts/fetchers/ListResult';
import { CollectionMapper } from '~src/ts/mappers/CollectionMapper';

import { BaseParamsBuilderResourceQuery } from '~src/ts/resources/ResourceQuery';
import { IFieldValue } from '~src/ts/ServerApi/types/IFieldValue';
import { FilterOps, ILeafFilterClause, IStringValuedFilterClause } from '~src/ts/ServerApi/types/IFilterClause';
import { collectionsRequestConfig, COLLECTIONS_PATH, getFilterUrlParam } from './CollectionResourceQueryHelpers';

export interface FieldValue {
  readonly count: number;
  readonly label: string;
  readonly value: string;
}

export type GetFieldValuesResponse = FieldValue[];

abstract class FieldValuesQuery extends BaseParamsBuilderResourceQuery<IFieldValue> {

  private matchText: string = '';

  abstract getUrl(): string;

  public getSlice(start: number, size: number): Promise<ListResult<IFieldValue>> {
    let queryParams: {search?: string, sort?: string, filter?: string, labelMatchText?: string} = {};
    let filters: ILeafFilterClause[] = this.getFilters();
    const matchesFilter = filters.find((clause) => clause.operator === FilterOps.matches);
    if (matchesFilter) {
      const searchTerm = (matchesFilter as IStringValuedFilterClause).value;
      queryParams.search = searchTerm;
    }

    const filterParams = getFilterUrlParam(this.getFilters());

    if(filterParams) {
      queryParams.filter = filterParams;
    }

    if (this.matchText) {
      queryParams.labelMatchText = `"${this.matchText}"`;
    }

    let queryString = '';
    if (!_.isEmpty(queryParams)) {
      queryString = '?';
      queryString += _.pairs(queryParams).map((value) => value[0]+'='+value[1]).join('&');
    }

    const url = this.getUrl() + queryString;
    const requestConfig = collectionsRequestConfig('GET', url);
    const http = ServiceLocator.get<IHttpService>('$http');

    return toNativePromise(http(requestConfig).then((response: IHttpResponse<GetFieldValuesResponse>) => {
      return CollectionMapper.mapFieldValuesList(response);
    }));
  }

  public withMatchText(matchText: string) {
    this.matchText = matchText;
    return this;
  }

  public getCount(): IPromise<number> {
    throw new Error('FieldValuesQuery getCount not implemented.');
  }

  public getFirst(): IPromise<any> {
    throw new Error('FieldValuesQuery getFirst not implemented.');
  }
}


export class CollectionItemsFieldValuesQuery extends FieldValuesQuery {
  public constructor(private collectionLuid: string, private filterField: string) {
    super();
  }

  getUrl(): string {
    return COLLECTIONS_PATH + '/' + this.collectionLuid + '/items/' + this.filterField + '/counts';
  }
}

export class CollectionFieldValuesQuery extends FieldValuesQuery {

  public constructor(private filterField: string) {
    super();
  }

  getUrl(): string {
    return COLLECTIONS_PATH + '/' + this.filterField + '/counts';
  }
}
